import React, {Component} from "react";
import {withRouter, NavLink} from "react-router-dom";
import {connect} from "react-redux";
import {Form, Input, Button, Select, message, Spin, Checkbox} from "antd";
import CloudFlyerAPI from "../../../api/CloudFlyerAPI";
import {Row, Col, Tooltip as Toltip, Popover} from 'antd';

import arrowLeft from "../../../assets/img/icon/arrow-left-icon.svg";
import wasabiDarkLogo from "../../../assets/logo/amove-dark-logo.svg";

import "./editPackage.scss";
import queryString from "query-string";

class editFeature extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            formValid: true,
            sso: false,
            logs: false,
        };
    }

    componentDidMount() {
        setTimeout(() => {
            const queryParams = queryString.parse(this.props.location.search);
            const queryData = queryParams.data ? JSON.parse(queryParams.data) : {};
            this.props.form.setFieldsValue({
                name: queryData.name,
                description: queryData.description,
                price: queryData.price,
                priceID: queryData.priceId,
                duration: queryData.duration.toString(),
                featureType: queryData.featureType.toString(),
            });
            console.log(queryData.sso)
            console.log(queryData.logs)
            this.setState({ sso: queryData.sso, logs : queryData.logs });

        }, 0);
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.setState({ loading: true });
        const {name, description, price, priceID, duration, featureType} = this.props.form.getFieldsValue();
        const queryParams = queryString.parse(this.props.location.search);
        const queryData = queryParams.data ? JSON.parse(queryParams.data) : {};

        CloudFlyerAPI.product_features
            .updateFeature({
                "id": queryData.id,
                "name": name,
                "description": description,
                "price": parseInt(price),
                "priceId": priceID,
                "duration": parseInt(duration),
                "featureType": parseInt(featureType),
                "deleted": queryData.deleted
            })
            .then(() => {
                message.success("Feature updated Successfully!");
                this.setState({ loading: false });
                this.props.form.resetFields(); // Reset form after success
                this.props.history.push("/productFeatures" );
            })
            .catch((err) => {
                message.error("Something went wrong!");
                this.setState({ loading: false });
            });


    };
    checkIfFormIsFilled = () => {
        const values = this.props.form.getFieldsValue();
        const requiredFields = ["name", "price", "priceID", "duration", "featureType"];

        const allFieldsFilled = requiredFields.every(field => values[field] && values[field] !== "");
        this.setState({ formValid: allFieldsFilled });
    };

    render() {
        const {getFieldDecorator} = this.props.form;
        const {Option} = Select;
        const { loading, formValid } = this.state;
        return (
            <div className="add-new-user-container less-margin">
                <div className="back-wrapper">
                    <NavLink to="/productFeatures"><img src={arrowLeft} alt="icon"/> Back</NavLink>
                </div>
                <div className="content-box">
                    <div className="wasabiLogo">
                        <img alt="wasabi Logo" src={wasabiDarkLogo}/>
                    </div>

                    <div className="add-user-form">
                        <Form
                            layout="horizontal"
                            onSubmit={this.handleSubmit.bind(this)}
                            className="user-form"
                        >
                            <Form.Item>
                                {getFieldDecorator("name")(
                                    <Input placeholder="Name" className="user-input" onChange={this.checkIfFormIsFilled} />
                                )}
                            </Form.Item>
                            <Form.Item>
                                {getFieldDecorator("description")(
                                    <Input placeholder="Description" className="user-input" onChange={this.checkIfFormIsFilled} />
                                )}
                            </Form.Item>

                            <Row gutter={30} type="flex">
                                <Col className="gutter-row" md={12} span={24}>
                                    <Form.Item>
                                        {getFieldDecorator("price")(
                                            <Input placeholder="Price" className="user-input" type="number" onChange={this.checkIfFormIsFilled} />
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col className="gutter-row" md={12} span={24}>
                                    <Form.Item>
                                        {getFieldDecorator("priceID")(
                                            <Input placeholder="Price ID" className="user-input" onChange={this.checkIfFormIsFilled} />
                                        )}
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Form.Item>
                                {getFieldDecorator("duration")(
                                    <Select placeholder="Duration" onChange={this.checkIfFormIsFilled}>
                                        <Option value="1">Monthly</Option>
                                        <Option value="2">Annual</Option>
                                    </Select>
                                )}
                            </Form.Item>
                            <Form.Item>
                                {getFieldDecorator("featureType")(
                                    <Select placeholder="Feature Type" onChange={()=>{
                                        console.log("Duration changed")
                                        this.checkIfFormIsFilled()
                                    }}>
                                        <Option value="4">AdminUser</Option>
                                        <Option value="8">CreativeUser</Option>
                                        <Option value="16">StandardUser</Option>
                                        <Option value="32">Connection</Option>
                                        <Option value="64">Project</Option>
                                        <Option value="128">Team</Option>
                                        <Option value="256">Drive</Option>
                                        <Option value="512">Sync</Option>
                                        <Option value="1024">SSO</Option>
                                        <Option value="2048">Logs</Option>
                                        <Option value="4096">FreeUser</Option>
                                        <Option value="8192">FreeConnection</Option>
                                    </Select>
                                )}
                            </Form.Item>
                            <Form.Item>
                                <Button
                                    className="user-btn"
                                    type="primary"
                                    size="large"
                                    // loading={this.state.loading}
                                    loading={loading}
                                    htmlType="submit"
                                    disabled={!formValid}
                                    block
                                >
                                    Save
                                </Button>
                            </Form.Item>
                        </Form>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(connect()(Form.create()(editFeature)));
